"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Subtitle2", {
    enumerable: true,
    get: function() {
        return Subtitle2;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _createPreset = require("../createPreset");
const _useSubtitle2Stylesstyles = require("./useSubtitle2Styles.styles");
const Subtitle2 = (0, _createPreset.createPreset)({
    useStyles: _useSubtitle2Stylesstyles.useSubtitle2Styles,
    className: _useSubtitle2Stylesstyles.subtitle2ClassNames.root,
    displayName: 'Subtitle2'
});
